import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styles from './styles.less';
import CanvasContainer from '../CanvasContainer';
import classnames from 'classnames';
import {
  loadReviewProject,
  nextReviewSpread,
  previousReviewSpread,
} from '../../../../ducks/reviewProject';

import { renderCanvasFromStore } from '../../../../ducks/navigation';
import * as Selectors from '../../../../reducers/selectors';
import PicabooConstants from '../../../../common/PicabooConstants';
import { isMobile } from '../../../../components/PicabooResponsive';
import { isPURBook } from '../../../../utils/subtypeHelper';
import MaterialIcon from '../../../../components/MaterialIcon';

const ReviewContainer = ({
  dispatch,
  reviewSection,
  reviewProject,
  project,
  leftPageNumber,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    const projectPK = project.get('projectPK');
    dispatch(loadReviewProject(projectPK));
  }, []);

  useEffect(() => {
    if (reviewProject.get('isLoaded')) {
      dispatch(renderCanvasFromStore());
    }
  }, [reviewProject]);

  const navigateForward = () => {
    dispatch(nextReviewSpread());
  };

  const navigateBack = () => {
    dispatch(previousReviewSpread());
  };

  const getOnlyPage = () => {
    if (
      project &&
      project.get('reviewPages') &&
      project.get('reviewPages').size > 0
    ) {
      const pageRef = project.get('reviewPages').get(0);
      return reviewProject.get('pages').get(pageRef);
    }

    return null;
  };

  const getSinglePage = () => {
    return (
      <div className={styles.canvasContainer}>
        <CanvasContainer
          reviewMode={true}
          reviewProject={reviewProject}
          page={getOnlyPage()}
          uid="2"
          key="2"
          twoPage={false}
          showStacked={false}
        />
      </div>
    );
  };

  const getTwoPage = () => {
    return (
      <div className={styles.canvasContainer}>
        <CanvasContainer
          page={getLeftPage()}
          uid="2"
          key="2"
          twoPage={true}
          showStacked={false}
          reviewMode={true}
          reviewProject={reviewProject}
        />
        <CanvasContainer
          page={getRightPage()}
          uid="3"
          key="3"
          twoPage={true}
          showStacked={false}
          reviewMode={true}
          reviewProject={reviewProject}
        />
      </div>
    );
  };

  const getEditor = () => {
    if (reviewProject.get('pages')?.size === 2) {
      return getTwoPage();
    }
    return getSinglePage();
  };

  const isTwoPage = () => {
    if (project == undefined || section == undefined) {
      return false;
    }
    const projectType = project.get('type');
    const isCover = isCoverSection();

    //this needs to check to see if we're on the cover as well
    return !isCover && projectType === PicabooConstants.PRODUCT_TYPES.BOOK;
  };

  const isCoverSection = () => {
    if (!reviewSection) {
      return false;
    }
    const sectionType = reviewSection.get('type');
    return (
      sectionType === PicabooConstants.SECTION_TYPES.TYPE_COVER ||
      sectionType === PicabooConstants.SECTION_TYPES.TYPE_SOFTCOVER
    );
  };

  const getLeftPage = () => {
    if (
      project &&
      project.get('reviewPages') &&
      project.get('reviewPages').size > 0
    ) {
      const pageRef = project.get('reviewPages').get(0);
      return reviewProject.get('pages').get(pageRef);
    }

    return null;
  };

  const getRightPage = () => {
    if (
      project &&
      project.get('reviewPages') &&
      project.get('reviewPages').size > 0
    ) {
      const pageRef = project.get('reviewPages').get(1);
      return reviewProject.get('pages').get(pageRef);
    }

    return null;
  };

  const getPageNumbers = () => {
    if (isCoverSection()) {
      return (
        <div className={styles.pageNumbersContainer}>
          <div className={classnames(styles.coverLabels)}>
            <div className={styles.spineLabel}>
              <span>
                <MaterialIcon
                  onClick={navigateBack.bind(this)}
                  icon="keyboard_arrow_left"
                  classOverride={styles.navigationIcon}
                />
                {t('EDITORCONTAINER.WORKSPACECONTAINER.Cover')}
                <MaterialIcon
                  onClick={navigateForward.bind(this)}
                  icon="keyboard_arrow_right"
                  classOverride={styles.navigationIcon}
                />
              </span>
            </div>
            <div className={styles.frontLabel}>
              <span></span>
            </div>
          </div>
        </div>
      );
    } else if (project.get('reviewPages') && !isCoverSection()) {
      const isTwoPage = project.get('reviewPages').size === 1;
      const isLeftInside =
        getLeftPage().get('pageType') === PicabooConstants.PAGE_TYPES.COVER;
      const isRightInside = isTwoPage
        ? isLeftInside
        : getRightPage().get('pageType') === PicabooConstants.PAGE_TYPES.COVER;
      const isPur = isPURBook(project.get('style'));
      let leftPageNum = isLeftInside
        ? leftPageNumber <= 1
          ? t(
              'EDITORCONTAINER.WORKSPACECONTAINER.Inside cover, cannot be edited',
            )
          : t(
              'EDITORCONTAINER.WORKSPACECONTAINER.Inside flyleaf, cannot be edited',
            )
        : `${leftPageNumber - 1}`;
      let rightPageNum = isRightInside
        ? isTwoPage && leftPageNumber <= 1 && !isPur
          ? t(
              'EDITORCONTAINER.WORKSPACECONTAINER.Inside flyleaf, cannot be edited',
            )
          : t(
              'EDITORCONTAINER.WORKSPACECONTAINER.Inside cover, cannot be edited',
            )
        : `${leftPageNumber}`;

      let pageNumPosition = 'side';

      return (
        <div className={styles.pageNumbersContainer}>
          <div
            className={
              isMobile()
                ? styles.pageNumbersInnerSideMobile
                : pageNumPosition === 'bottom'
                  ? styles.pageNumbersInner
                  : styles.pageNumbersInnerSide
            }
          >
            <div
              className={
                isLeftInside && pageNumPosition === 'side'
                  ? styles.insideCoverLabel
                  : null
              }
            >
              <span></span>
            </div>
            <div className={styles.spineLabel}>
              <span>
                <MaterialIcon
                  onClick={navigateBack.bind(this)}
                  icon="keyboard_arrow_left"
                  classOverride={styles.navigationIcon}
                />
                {leftPageNum} {t('EDITORCONTAINER.WORKSPACECONTAINER.-')}{' '}
                {rightPageNum}
                <MaterialIcon
                  onClick={navigateForward.bind(this)}
                  icon="keyboard_arrow_right"
                  classOverride={styles.navigationIcon}
                />
              </span>
            </div>
            <div
              className={
                isRightInside && pageNumPosition === 'side'
                  ? styles.insideCoverLabel
                  : null
              }
            >
              <span></span>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div id="reviewContainer" className={styles.reviewContainer}>
      <div className={styles.innerWrapper}>
        <div className={styles.workspaceInner} style={{ width: '100%' }}>
          <div
            className={styles.workspaceMiddle}
            id="workspaceMiddle"
            style={{ display: 'flex' }}
          >
            {reviewProject.get('isLoaded') &&
              project.get('reviewPages') &&
              getEditor()}
          </div>
        </div>
        {project.get('reviewPages') && getPageNumbers()}
      </div>
    </div>
  );
};

export function mapStateToProps(state) {
  return {
    reviewSection: Selectors.reviewSectionSelector(state),
    project: Selectors.projectMetadataSelector(state),
    reviewProject: Selectors.reviewProjectSelector(state),
    leftPageNumber: Selectors.leftReviewPageNumber(state),
  };
}

export default connect(mapStateToProps)(ReviewContainer);
